// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_infoContainer__DdevY {
  display: flex;
  width: 300px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
}

.styles_serverError__J42vr {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 0.5em;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__J42vr span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_logoText__mUGvp {
  display: none;
}

.styles_textMobile__hY4rr {
  font-style: normal;
  text-align: center;
  margin: 2em 0;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  color: #575757;
  margin: 20px 0;
}

.styles_text__V94sq {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin: 20px 0;
}

.styles_title__-An2X {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  text-align: center;
  margin-top: 0;
}

@media only screen and (max-width: 800px) {
  .styles_logoText__mUGvp {
    cursor: pointer;
    font-family: IranSans_Bold;
    font-size: 37px;
    text-decoration: none !important;
    outline: 0;
    display: flex;
    align-items: center;
  }
  .styles_infoContainer__DdevY {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/FormHead/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AACF;;AACA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,cAAA;AACF;;AACA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,kBAAA;EAGA,aAAA;AADF;;AAKA;EACE;IACE,eAAA;IAGA,0BAAA;IACA,eAAA;IAEA,gCAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;EALF;EAOA;IACE,WAAA;EALF;AACF","sourcesContent":[".infoContainer {\n  display: flex;\n  width: 300px;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: column;\n  margin:0 auto;\n}\n\n.serverError {\n  background: #ff9315;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 0.5em;\n  margin-top: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.logoText {\n  display: none;\n}\n.textMobile {\n  font-style: normal;\n  text-align: center;\n  margin: 2em 0;\n\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 20px;\n  color: #575757;\n  margin: 20px 0;\n}\n.text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  // color: #707070;\n  margin: 20px 0;\n}\n.title {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n  /* identical to box height, or 143% */\n\n  text-align: center;\n\n  // color: #d10a0a;\n  margin-top: 0;\n  // margin-bottom: 20px;\n}\n\n@media only screen and (max-width: 800px) {\n  .logoText {\n    cursor: pointer;\n    // color: #d8000d;\n\n    font-family: IranSans_Bold;\n    font-size: 37px;\n    // color: #e30813 !important;\n    text-decoration: none !important;\n    outline: 0;\n    display: flex;\n    align-items: center;\n  }\n  .infoContainer {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainer": `styles_infoContainer__DdevY`,
	"serverError": `styles_serverError__J42vr`,
	"logoText": `styles_logoText__mUGvp`,
	"textMobile": `styles_textMobile__hY4rr`,
	"text": `styles_text__V94sq`,
	"title": `styles_title__-An2X`
};
export default ___CSS_LOADER_EXPORT___;
